import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/CustomerApiNew';
import './MainPage.css'; // Use your existing global CSS


const ServiceCard = ({ service }) => {
	const navigate = useNavigate();

	const handleClick = () => {
		// You can use this to navigate to the specific service page
		navigate(`/service/${service.name.toLowerCase().replace(/\s+/g, '-')}`);
	};

	return (
		<div className="service-card" onClick={handleClick}>
			<div className="card-image-placeholder">
				{/* Placeholder for your image component or <img> tag */}
				{/* Replace src with actual image URL: <img src={service.imageUrl} alt={service.name} /> */}
				<span>{service.icon || '🖼️'}</span>
			</div>
			<div className="card-content">
				<h3 className="card-title">{service.name}</h3>
				<p className="card-description">{service.description}</p>
			</div>
		</div>
	);
};

const ServiceSlidesPage = () => {
	// Static data array, replacing iteration on backend services
	const [serviceData, setServiceData] = useState([
		/*{ name: "Nurse", description: "Certified care for medical needs like injections, wound dressing, patient care.", icon: "🩺" },
		{ name: "Home Care", description: "Comprehensive support for daily living right at your home like Cleaning.", icon: "🏠" },
		{ name: "Care Taker", description: "Daily assistance, including baby care and specialized old age support.", icon: "🧑‍🍼" },
		{ name: "Physio", description: "Recovery and physical rehabilitation sessions.", icon: "🏃" },
		{ name: "Ambulance", description: "Emergency transport services 24/7.", icon: "🚑" },
		{ name: "CA", description: "Tax filing, auditing, and financial consulting services.", icon: "📊" },
		{ name: "Lawyer", description: "Legal advice, documentation, and court representation.", icon: "⚖️" },
		{ name: "Coaching", description: "Educational support, tuition, and academic help.", icon: "📚" },
		{ name: "GYM", description: "Fitness facility access and personal training.", icon: "🏋️" },
		{ name: "Yoga", description: "Mind-body wellness classes and instructors.", icon: "🧘" },
		{ name: "Zumba", description: "Fun, high-energy dance fitness classes.", icon: "💃" },
		{ name: "Martial Arts", description: "Self-defense classes and physical discipline training.", icon: "🥋" },
		{ name: "Wedding Planner", description: "Expert coordination and design for your perfect day.", icon: "💍" },
		{ name: "Catering Service", description: "Delicious menus and professional service for every palate.", icon: "🍽️" },
		{ name: "Photographer", description: "Capturing timeless moments with creative professional shots.", icon: "📸" },
		{ name: "Makeup Artist", description: "Professional styling and beauty enhancements for any occasion.", icon: "💄" }*/

		{ name: "Civil Engineer", description: "Expert structural design, blueprint planning, and structural stability checks for your property.", icon: "🏗️" },
		{ name: "Building Contractor", description: "End-to-end execution of home construction from laying foundations to the final turnkey structure.", icon: "🧱" },
		{ name: "Interior Designer", description: "Creative spatial planning, 3D layouts, and aesthetic customization of your living spaces.", icon: "📐" },
		{ name: "Tiling Contractor", description: "Precision laying of floor tiles, bathroom marbles, granite countertops, and wall backsplashes.", icon: "🔲" },
		{ name: "Electrician", description: "Safe and certified house wiring, main line setup, and installation of home appliances or fixtures.", icon: "⚡" },
		{ name: "Plumber", description: "Installation of bathroom fittings, water pipelines, drainage solutions, and water tank setups.", icon: "🚰" },
		{ name: "Painter", description: "Professional wall putty preparation, interior/exterior painting, textures, and waterproof coatings.", icon: "🎨" },
		{ name: "Carpenter", description: "Custom modular kitchen setups, wooden wardrobes, bed frames, doors, and hardware fittings.", icon: "🪚" },
		{ name: "Glass Installer", description: "Fitting glass partitions, shower cubicles, custom wall mirrors, and toughened glass elevations.", icon: "🪟" },
		{ name: "Window Installer", description: "Installation of modern UPVC windows, aluminum sliding frames, and custom louvers.", icon: "🪟" },
		{ name: "Railing Installer", description: "Fabrication and installation of stainless steel, iron, or glass railings for stairs and balconies.", icon: "🪜" },
		{ name: "Banquet Hall", description: "Premium event venues offering spacious halls, decoration arrangements, and integrated catering.", icon: "🏛️" },
		{ name: "Event Planner", description: "Comprehensive management of themes, vendor coordination, timelines, and execution for your celebrations.", icon: "🎉" },
		{ name: "Photographer", description: "Candid and traditional cinematic wedding coverage, pre-wedding shoots, and high-end albums.", icon: "📸" },
		{ name: "Makeup Artist", description: "Professional bridal, party, and groom grooming packages tailored to your skin type and wedding themes.", icon: "💄" },
		{ name: "Mehendi Artist", description: "Exquisite application of traditional bridal, Arabic, and custom portrait henna designs.", icon: "🌿" },
		{ name: "Wedding Choreographer", description: "Custom dance routines, step-by-step sangeet training, and background dancer coordination for families.", icon: "💃" }
	]);

	// 1. Fetch initial service data
	useEffect(() => {
		const fetchLoaderData = async () => {
			try {
				// Use 'api.get'
				const response = await api.get("/api/v1/loader/load/service-data");
				setServiceData(response.data);
			} catch (err) {
			}
		};
		fetchLoaderData();
	}, []);

	return (
		<div className="service-slides-container">
			<h2>Our Top Services</h2>
			<div className="services-grid">
				{serviceData.map(service => (
					<ServiceCard key={service.name} service={service} />
				))}
			</div>
		</div>
	);
};

export default ServiceSlidesPage;
